import React from 'react';
import { UserGuideChapter } from '../../types/userGuide';
import { Lock, FileText } from 'lucide-react';
import { clsx } from 'clsx';

interface GuideSidebarProps {
  chapters: UserGuideChapter[];
  activeChapterId: string;
  onSelectChapter: (id: string) => void;
}

export const GuideSidebar: React.FC<GuideSidebarProps> = ({
  chapters,
  activeChapterId,
  onSelectChapter,
}) => {
  return (
    <div className="w-64 bg-white border-r border-gray-200 h-full overflow-y-auto hidden md:block">
      <div className="p-4 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-800">Chapters</h3>
      </div>
      <ul className="py-2">
        {chapters.map((chapter) => (
          <li key={chapter.id}>
            <button
              onClick={() => onSelectChapter(chapter.id)}
              className={clsx(
                'w-full text-left px-4 py-3 flex items-center justify-between transition-colors',
                activeChapterId === chapter.id
                  ? 'bg-blue-50 border-r-4 border-blue-600 text-blue-700'
                  : 'text-gray-700 hover:bg-gray-50'
              )}
            >
              <div className="flex items-center space-x-3">
                <FileText className="w-4 h-4" />
                <span className="text-sm font-medium line-clamp-2">
                  {chapter.title}
                </span>
              </div>
              {!chapter.is_accessible && (
                <Lock className="w-4 h-4 text-gray-400 flex-shrink-0" />
              )}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
};
